import BackBtn from './BackBtn.vue';

export default BackBtn;
